import Pool from '@duckness/pool'

import { BlockModelShape } from '@aytm/app/insights/dashboard/models/BlockModel'
import type {
  InsightsDashboardInitParams,
  InsightsDashboardPoolState
} from '@aytm/app/insights/dashboard/duckness/ducks/types'
import type { DuckNamesType } from '@aytm/app/insights/dashboard/duckness/ducks'

export type InitDashboardParams = {
  blockType: BlockModelShape['type']
  blockUID: string | null
  viewBlock?: boolean | BlockModelShape
}

export type UpdateBlockParams = {
  blockUID: string | null
  update: unknown
  commit: unknown
}

export type UpdateBlocksParams = {
  actionType: number
  source: unknown
  target?: unknown
  append?: boolean
  ids?: string[]
}

export type CopyBlockParams = {
  blockUID: string
  patch?: Partial<BlockModelShape> | null
}

export declare function dispatch(
  duckName: DuckNamesType,
  actionName: string,
  params: UpdateBlockParams | UpdateBlocksParams | CopyBlockParams // Notice the 's' in the latter case
): void

export const TypedPool = Pool<InsightsDashboardPoolState, InsightsDashboardInitParams>
